import React, { useEffect, useState } from 'react'
import styles from './../../recentCustomers.module.scss'
import { Table } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { DASHBOARD_LARGEST_INVOICING } from '../../../../../../../Utils/GlobalConstants'
import { api } from '../../../../../../../Utils/API'
import loadingGif from "../../../../../../../Assets/Images/Animations/loading-management-console.gif"

const LargestCustomerByInvoicing = (props) => {
    const [data, setData] = useState([])                                     // for storing data (Largest invoicing)
    const navigate = useNavigate()                                             // to use navigate function from react router dom  
    const [loadingState, setLoadingState] = useState(true)                      // loading state           

    // Header Authorization for General API's
    const config = {
        headers: {
            "Authorization": `${localStorage.getItem("token_type")} ${localStorage.getItem("access_token")}`,
        },
    };

    // Function to call Recent customers data
    async function GetLargestInvoicing() {
        await api.get(`${DASHBOARD_LARGEST_INVOICING}`, config)
            .then(resp => {
                setLoadingState(false);
                if (resp.status == 200) {
                    setData(resp.data);
                }
            })
            .catch(error => {
                if (error?.status == 401 || error?.response?.status == 401) {
                    props.Logout();
                }
                else {
                }
            });
    };

    //useEffect for calling get api on initial load
    useEffect(() => {
        GetLargestInvoicing();
    }, [])

    return (
        <div className={styles["recent-customers-data"]}>
            {data.length > 0 && !loadingState && 
                <Table>
                    <thead>
                        <tr>
                            <th>Customers</th>
                            {<th className={(props.isDisabledCustomers && props.isDisabledManage) ? "d-none" : "text-center"}>Actions</th>}
                        </tr>
                    </thead>
                    <tbody className={styles["recent-customers-tbody"]}>
                        {data.map((td) => {
                            return (
                                <>
                                    <tr>
                                        <td className={`${styles['customername-td']}`}>
                                            <span title={td.customerName} className={`${styles['big-customer-name']}`}>{td.customerName}</span>
                                        </td>
                                        {<td className={`text-center ${styles['recent-customers-actions']}`}>
                                            {!props.isDisabledCustomers &&
                                                <span className={`dashboard-actions-icon1 mr-3 cpointer ${styles['disable-button']}`}
                                                    onClick={() => { navigate("/my-customers/edit-customer", { state: { customerCode: td.customerCode, customerName: (td.customerName.split(" "))[0] }, }); }}
                                                    id={td.customerCode}>
                                                </span>}
                                            {!props.isDisabledManage &&
                                                <span className="invoices-widget-navigation cpointer"
                                                    onClick={() => navigate("/billing/invoice", {
                                                        state: {
                                                            searchData: td.customerName,
                                                            customerId: td.customerCode,
                                                            fromQuickActions: true
                                                        }
                                                    })}
                                                    id={td.customerCode}>
                                                </span>
                                            }
                                        </td>}
                                    </tr>
                                </>
                            )
                        })
                        }
                    </tbody>
                </Table>
            }
            {data.length < 1 && !loadingState && 
                <div className={styles["recent-customers-loading-state"]}>
                    <p>No data to display</p>
                </div>

            }
            {data.length < 1 && loadingState &&
                <div className={styles["recent-customers-loading-state"]}>
                    <div className={styles["no-data-customers"]}><img className="management-console-loading-icon" src={loadingGif} /><p className="text-medium text-strong management-console-loading-text">Loading...</p></div>
                </div>
            }
        </div>
    )
}

export default LargestCustomerByInvoicing

